module.exports = __webpack_public_path__ + "static/media/RachitResume2021Latest.7a1f29da.pdf";